import { useEffect, useState } from "react";
import { Phone, Scissors, Loader2, Tag } from "lucide-react";
import { fetchCoupons } from "../lib/api";
import { BUSINESS } from "../config/business";
import SEO from "../components/SEO";
import { FadeUp, MaskedLine } from "../components/anim";

export default function Coupons() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    fetchCoupons().then(setItems).catch(() => setItems([]));
  }, []);

  const discount = (c) => {
    if (!c.discount_value || c.discount_value === "0") return "Special";
    return c.discount_type === "%" ? `${c.discount_value}% OFF` : `$${c.discount_value} OFF`;
  };

  return (
    <div data-testid="coupons-page">
      <SEO
        title={`Smog Check Coupons Modesto, CA | ${BUSINESS.name}`}
        description="Save on your smog check in Modesto with our latest coupons and specials, including $20 off and a 90-day free retest."
        keywords="smog check coupon Modesto, smog discount Modesto CA, $20 off smog"
        path="/coupons"
      />
      <section className="bg-white aurora relative overflow-hidden">
        <div className="section relative z-10 py-14">
          <p className="kicker">Coupons & Specials</p>
          <h1 className="mt-2 font-head font-extrabold text-4xl sm:text-5xl text-ink">
            <MaskedLine lines={[{ text: "Save on Your Smog Check" }]} />
          </h1>
          <p className="mt-4 text-ink/70 font-body max-w-2xl">Mention or show any coupon at the time of service. Can't be combined with other offers.</p>
        </div>
      </section>

      <section className="section py-14">
        {items === null && <div className="flex justify-center py-20 text-volt"><Loader2 className="h-8 w-8 animate-spin" /></div>}
        {items && items.length === 0 && <div className="text-center py-20 text-ink/60 font-body">No active coupons right now — call {BUSINESS.phoneDisplay} for current specials.</div>}
        <div className="grid md:grid-cols-2 gap-6">
          {items?.map((c, i) => (
            <FadeUp key={c.id} delay={i * 0.05}>
              <div className="dashed-ticket rounded-2xl p-7" data-testid={`coupon-card-${c.id}`}>
                <div className="flex items-start justify-between gap-4">
                  <div className="grid h-11 w-11 place-items-center rounded-full bg-cta text-ink"><Scissors className="h-5 w-5" /></div>
                  <span className="font-head font-extrabold text-2xl text-volt">{discount(c)}</span>
                </div>
                <h2 className="mt-4 font-head font-bold text-xl text-ink">{c.title}</h2>
                <p className="mt-1 text-sm text-ink/70 font-body">{c.description}</p>
                <div className="mt-4 flex flex-wrap items-center gap-3 text-xs">
                  {c.code && <span className="inline-flex items-center gap-1 rounded-full bg-white px-3 py-1 font-mono font-bold text-ink border border-line"><Tag className="h-3 w-3" />{c.code}</span>}
                  <span className="text-ink/50 font-body">{c.expiration_date ? `Expires ${c.expiration_date}` : "No expiration"}</span>
                </div>
                {c.terms && <p className="mt-3 text-[11px] text-ink/50 font-body">{c.terms}</p>}
                <a href={`tel:${BUSINESS.phoneTel}`} className="btn-cta mt-5 w-full"><Phone className="h-4 w-4" /> Call to Redeem</a>
              </div>
            </FadeUp>
          ))}
        </div>
      </section>
    </div>
  );
}
